import createDebug from 'debug'

export default function(name: string) {
  return createDebug(`360-training-frontend:${name}`)
}
